import { SurveyForm } from 'ui/components/buyer/patterns/SurveyForm/SurveyForm';

/**
 * 買い手アンケートフォーム
 */
export const BuyerSurveyForm: React.FC = () => {
    return <SurveyForm />;
};
